import axios from 'axios';
import { persistor } from 'src/redux/store';
import { getBrowserTimezone } from 'src/utils/viewerTimezone';

const BaseApiUrl = window.API_URL;

export const axiosInterceptor = axios.create({
    baseURL: BaseApiUrl,
    headers: {
        // Skips ngrok's browser-warning interstitial when the backend is tunneled via ngrok for local dev
        'ngrok-skip-browser-warning': 'true',
    },
});

axiosInterceptor.interceptors.request.use(
    (config: any) => {
        if (localStorage.getItem('token')) {
            config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
        }

        if (localStorage.getItem('accessToken')) {
            config.headers.AccessToken = localStorage.getItem('accessToken');
        }

        // The reader's clock, so the backend can remember it on the portal user (notifications
        // and texts have no browser to ask). getUserDetails stores it when it changes.
        const browserTimezone = getBrowserTimezone();
        if (browserTimezone) config.headers['X-Viewer-Timezone'] = browserTimezone;

        return config;
    },
    (error: any) => Promise.reject(error)
);

axiosInterceptor.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            persistor.pause(); // stop redux-persist from re-writing state after reset
            persistor.purge();
            localStorage.clear();
            window.location.href = '/';
        }

        return Promise.reject(error);
    }
);

axiosInterceptor.interceptors.response.use(
    (response: any) => (response.status === 200 ? response.data : response),
    (error: any) => Promise.reject(error)
);
